export function log(level: 'info' | 'error' | 'warn', ...args: any[]) {
  if (process.env.TEST !== 'true') {
    // eslint-disable-next-line no-console
    console[level](...args);
  }
}
